import { Construction } from "lucide-react";
import { useLocation } from "../router";
export function PlaceholderPage() {
  const location = useLocation();
  return <div className="empty-state panel full placeholder"><Construction /><h2>Module en préparation</h2><p>La fondation de <code>{location.pathname}</code> est prête à accueillir les prochaines règles métier.</p></div>;
}
